import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PickHistoryComponent } from './pick-history/pick-history.component';
import { StatisticsComponent } from './statistics/statistics.component';
import { UpcomingPicksComponent } from './upcoming-picks/upcoming-picks.component';
import { UserChatComponent } from './user-chat/user-chat.component';
import { UserProfileComponent } from './user-profile.component';
import { SharedModule } from '@app/core/shared/shared.module';
import { ValidSportResolver } from '@app/core/resolvers/valid-sport.resolver';
import { UserSlugResolver } from '@app/core/resolvers/user-slug.resolver';

const routes: Routes = [
  {
    path: '',
    component: UserProfileComponent,
    resolve: { userId: UserSlugResolver },
    children: [
      {
        path: 'statistics',
        component: StatisticsComponent,
      },
      {
        path: 'pick-history',
        component: PickHistoryComponent,
        data: {
          title: 'Pick History',
          meta: [{ name: 'description', description: 'kingpin, Pick History' }],
        },
      },
      {
        path: 'chat',
        component: UserChatComponent,
        data: {
          title: 'Chat',
          meta: [{ name: 'description', description: 'kingpin, chat' }],
        },
      },
      {
        path: 'upcoming-picks',
        component: UpcomingPicksComponent,
        data: {
          title: 'Upcoming Picks',
          meta: [
            { name: 'description', description: 'kingpin,Upcoming Picks' },
          ],
        },
      },
    ],
  },
];

@NgModule({
  declarations: [
    UserProfileComponent,
    StatisticsComponent,
    UserChatComponent,
    UpcomingPicksComponent,
    PickHistoryComponent,
  ],
  imports: [CommonModule, RouterModule.forChild(routes), SharedModule],
})
export class UserProfileModule {}
